import React, { Component } from "react";

import './Projects.css';
import { render } from "@testing-library/react";

import Typewriter from 'typewriter-effect';
import Clock from 'react-live-clock';
import Delayed from "../Delayed";


class Projects extends Component {
  constructor() {
    super();
    this.state = {
      name: "Vinayak Goswami",
    };
  }

  render(){
    return(
      <div>

        <h1>
          vinayak@goswami:$
        </h1>

        <div className="scrollable-div">
          <Typewriter
            onInit={(typewriter) => {
              typewriter
                .typeString('<span style="color:#52a563;">❯</span>  ')
                .pauseFor(1500)
                .typeString('cat projects.txt')
                .pauseFor(300)
                .typeString('<br><br>')
                .pasteString('<h3> Deepfake Detection</h3>')
                .pasteString('<br> A website to help detect deepfakes and prevent the spread of fake news by the use of deep fakes of public figures. Built using Tensorflow, the model to detect deepfakes and a react based website for the user to interact with this model.')
                .pasteString('<br> &emsp; <a href="https://github.com/vini7148/fake_news_detection" class="linkr">Source Code</a>')
                .pauseFor(300)
                .typeString('<br><br>')
                .pasteString('<h3> Timetable Management Website</h3>')
                .pasteString('<br> Built using Python3 and Django, an automated solution to manage institutional timetable for teachers as well as classes. It only allows authorized user to manipulate the data.')
                .pasteString('<br> &emsp; <a href="https://vini7148.herokuapp.com" class="linkr">Live Website</a>')
                .pasteString('<br> &emsp; <a href="https://github.com/vini7148/TimeTable_Django" class="linkr">Source Code</a>')
                .pauseFor(300)
                .typeString('<br><br>')
                .pasteString('<h3> Distant Learning Website</h3>')
                .pasteString('<br> A remote education website built using Python3 and Django, it provides an online platform for students to study during the pandemic from the comfort of their home, students can even take notes and save them after logging in.')
                .pasteString('<br> &emsp; <a href="http://vini714841.pythonanywhere.com" class="linkr">Live Website</a>')
                .pasteString('<br> &emsp; <a href="https://github.com/vini7148/Distant_Learning_Solution" class="linkr">Source Code</a>')
                .pauseFor(300)
                .typeString('<br><br>')
                .pasteString('<h3> YOLOv3 API</h3>')
                .pasteString('<br> Implementation of YOLOv3 using TensorFlow (tf2.0). An API is also developed to interact with the computer vision model to send images and draw boxes around the detected objects')
                .pasteString('<br> &emsp; <a href="https://github.com/vini7148" class="linkr">Source Code</a>')
                .pauseFor(300)
                .typeString('<br><br>')
                .pasteString('<h3> YouTube Music CLI</h3>')
                .pasteString('<br> A Cli based light weight application to enjoy music through the terminal, this application uses YouTube platform to stream music from. The application also features a built in search feature and the ability to stream playlists also.')
                .pasteString('<br> &emsp; <a href="https://github.com/vini7148" class="linkr">Source Code</a>')
                .pauseFor(300)
                .typeString('<br><br>')
                .pasteString('<h3> Linux Rice (dotfiles)</h3>')
                .pasteString('<br> A personalized linux setup, made possible by i3-gaps wm, polybar, zsh along with a composter, picom for window effects')
                .pasteString('<br> &emsp; <a href="https://github.com/vini7148/dotfiles" class="linkr">Source Code</a>')
                .start();
            }}
          />
        </div>
      
      </div>

      // <div>

      //   <h1>
      //     vinayak@goswami:$ 
      //     {/* <span className="cursor">|</span>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;<Clock format={'HH:mm:ss'} ticking={true} /> */}
      //   </h1>

      //   <Typewriter className='dollar'
      //     onInit={(typewriter) => {
      //       typewriter
      //         .typeString('<span style="color:#52a563;">❯</span>  ')
      //         .pauseFor(1500)
      //         .typeString('cat projects.txt')
      //         .pauseFor(300)
      //         .typeString('<br>')
      //         .start();
      //     }}
      //   />

      //   <Delayed waitBeforeShow={5000}>
      //     <div className="scrollable-div">
      //       Project 1
      //     </div>
      //   </Delayed>
      
      // </div>
    );
  }
}

export default Projects;
